<template lang="pug">
  #all-reports
    h2 All Reports
    b-button-toolbar
      b-button-group.mx-1
        b-button(@click.stop.prevent="onExport") Export
      b-button-group.mx-1
        b-button(v-b-modal="'modalUploadReports'") Import
        b-modal(id="modalUploadReports" ref="modalUploadReports" size="lg"
                title="Upload reports file" @ok="$refs.importForm.submit()")
          slot(name="modal-header")
            b-alert.alert-danger(show).
              Danger! Importing reports will
              <strong>delete all existing reports</strong> before adding the new ones.
              Use with caution.
          form(ref="importForm" @submit.stop.prevent="")
            b-form-file(type="file" placeholder="Add CSV file" v-model="file" @change="onImport")
          .preview(v-if="importRows.length > 0")
            datatable.import-results(title="Import Preview" :columns="columns" :rows="importRows")
            b-button(variant="success" @click.stop.prevent="setAllReports(importRows)") Confirm Import
    datatable.all-reports(:columns="columns" :rows="allReports" v-if="allReports.length > 0")
</template>

<script>

import datatable from 'ansergy-datatable'
import downloadCSV from 'ansergy-datatable/lib/downloadCSV'
import parse from 'csv-parse'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'all-reports',
  components: { datatable },
  data () {
    return {
      file: null,
      importColumns: [],
      importRows: []
    }
  },
  computed: {
    ...mapState(['allReports']),
    columns () {
      return [
        { id: 'user_email', label: 'Email', tooltip: 'Email where the report will be sent' },
        { id: 'dow', label: 'DOW', tooltip: 'Day-of-week when the report will be sent' },
        // { id: 'tod', label: 'TOD', tooltip: 'Time-of-day when the report will be sent' },
        // { id: 'tod_template', label: 'TOD - Template', tooltip: 'Time-of-day that the template uses' },
        { id: 'name', label: 'Report Name', tooltip: 'Name of the report to be sent' }
      ]
    }
  },
  methods: {
    ...mapActions(['getAllReports', 'setAllReports']),
    onExport () {
      downloadCSV(this.columns, this.allReports)
    },
    onImport (e) {
      const files = e.target.files || e.dataTransfer.files
      const reader = new FileReader()
      reader.onload = (e) => {
        this.data = e.target.result
        parse(e.target.result, (err, output) => {
          if (err) {
            console.error(err)
          }
          this.importRows = output.slice(1, output.length).map((row) => {
            const result = {}
            for (let index in row) {
              result[this.columns[index].id] = row[index]
            }
            return result
          })
        })
      }
      reader.readAsText(files[0])
    }
  },
  mounted () {
    this.getAllReports()
  }
}
</script>

<style lang="stylus">
html .all-reports tfoot {
  display: none
}

html .preview {
  button {
    margin-top: 1em
  }
}

html .import-results {
  margin-top: 1em
  max-height: 350px
  overflow: scroll

  tfoot {
    display: none
  }
}
</style>



// WEBPACK FOOTER //
// all-reports.vue?4ba40c70